export const APPROVE_MODEL_SCOPE = `
  mutation ApproveModelScope($input: ApproveModelScopeInput!) {
    approveModelScope(input: $input) {
      scopeKey
      modelId
      accountId
      region
      status
      approvedAt
      approvedBy
    }
  }
`
